import "core-js/modules/es.promise.finally.js";
import { createElement, Fragment, useState, useEffect } from 'react';
import { useTheme, ThemeProvider } from 'emotion-theming';
import { css, cx, keyframes } from 'emotion';
import clsx2 from 'clsx';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { genYupValidatorBySchema } from '@ctxhou/ciaociao-validation';
import Select from 'react-select';
var breakpoints = [768, 992, 1200];
var mq = breakpoints.map(function (bp) {
  return "@media (max-device-width: " + bp + "px)";
});
var resetFormFieldStyle = /*#__PURE__*/css({
  name: "enlcqk-resetFormFieldStyle",
  styles: "margin:0;border:0;padding:0;display:inline-block;vertical-align:middle;white-space:normal;background:none;line-height:1;width:100%;position:relative;box-sizing:border-box;outline:0;;label:resetFormFieldStyle;"
});

var createStyle = function createStyle(_theme) {
  var theme = Object.assign({}, {
    themeColor: "#26c6da",
    bg: "#fff",
    textColor: "inherit",
    emotionBg: "#f7fafc",
    emotionHoverBg: "#edf2f7",
    inputBorderColor: "#cbd5e0",
    inputShadowColor: "#26c6da",
    iconButtonColor: "#cbd5e0",
    iconButtonHoverColor: "#999",
    buttonDisabledBg: "#E2E8F0",
    buttonDisabledColor: "#A0AEC0"
  }, _theme);
  var root = /*#__PURE__*/css({
    name: "4u7d68-root",
    styles: "font-family:system-ui, sans-serif;;label:root;"
  });
  var fieldStyle = /*#__PURE__*/css(resetFormFieldStyle, ";min-height:40px;transition:border-color 0.25s ease-in-out 0s,box-shadow 0.1s ease-in-out 0s,background-color 0.25s ease-in-out 0s,color 0.25s ease-in-out 0s;border-width:1px;border-style:solid;border-image:initial;border-radius:4px;padding:13px 9px;border-color:rgb(216,220,222);font-size:14px;background-color:rgb(255,255,255);color:rgb(47,57,65);&:focus{box-shadow:rgba(153,153,153,0.4) 0px 0px 0px 2px !important;}&:focus,&:hover{border-color:rgb(104,115,125) !important;}", mq[0], "{font-size:16px;};label:fieldStyle;");
  var fieldErrorStyle = /*#__PURE__*/css({
    name: "m2bhev-fieldErrorStyle",
    styles: "border-color:red !important;;label:fieldErrorStyle;"
  });
  var textAreaStyle = /*#__PURE__*/css(fieldStyle, ";resize:none;;label:textAreaStyle;");
  return Object.assign({}, theme, {
    classNames: {
      root: root,
      fieldStyle: fieldStyle,
      fieldErrorStyle: fieldErrorStyle,
      textAreaStyle: textAreaStyle
    }
  });
};

function SvgComponent() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    viewBox: "0 0 24 24",
    width: 20
  }, /* @__PURE__ */createElement("path", {
    d: "M8.75 17.612v4.638a.751.751 0 001.354.444l2.713-3.692zM23.685.139a.75.75 0 00-.782-.054l-22.5 11.75a.752.752 0 00.104 1.375l6.255 2.138 13.321-11.39L9.775 16.377l10.483 3.583a.753.753 0 00.984-.599l2.75-18.5a.751.751 0 00-.307-.722z"
  }));
}

function SvgComponent$1() {
  return /* @__PURE__ */createElement("svg", {
    version: "1.1",
    id: "Capa_1",
    height: 20,
    width: 20,
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384"
  }, /* @__PURE__ */createElement("g", null, /* @__PURE__ */createElement("g", null, /* @__PURE__ */createElement("path", {
    d: "M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594\n			c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448\n			c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813\n			C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z"
  }))), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null), /* @__PURE__ */createElement("g", null));
}

function SvgComponent$2() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    width: 20,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */createElement("path", {
    d: "m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 405.332031c-11.777344 0-21.332031-9.554687-21.332031-21.332031s9.554687-21.332031 21.332031-21.332031 21.332031 9.554687 21.332031 21.332031-9.554687 21.332031-21.332031 21.332031zm33.769531-135.636719c-7.550781 3.476563-12.4375 11.09375-12.4375 19.394532v9.578125c0 11.773437-9.535156 21.332031-21.332031 21.332031s-21.332031-9.558594-21.332031-21.332031v-9.578125c0-24.898438 14.632812-47.722656 37.226562-58.15625 21.738281-10.003906 37.4375-36.566406 37.4375-49.601563 0-29.394531-23.914062-53.332031-53.332031-53.332031s-53.332031 23.9375-53.332031 53.332031c0 11.777344-9.539063 21.335938-21.335938 21.335938s-21.332031-9.558594-21.332031-21.335938c0-52.925781 43.070312-96 96-96s96 43.074219 96 96c0 28.824219-25.003906 71.191407-62.230469 88.363281zm0 0"
  }));
}

function SvgComponent$3() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    width: 20,
    viewBox: "0 0 511.996 511.996",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */createElement("path", {
    d: "m230.9 253.371c13.369 8.913 36.827 8.914 50.199-.001.002-.001.005-.003.007-.004l227.865-151.911c-7.474-21.616-28.018-37.188-52.142-37.188h-401.663c-24.125 0-44.668 15.572-52.143 37.188l227.87 151.912c.003.002.005.002.007.004z"
  }), /* @__PURE__ */createElement("path", {
    d: "m297.746 278.328c-.003.002-.005.004-.007.005-11.702 7.801-26.724 11.702-41.741 11.702-15.02 0-30.036-3.9-41.739-11.703-.002-.001-.003-.002-.005-.003l-214.254-142.835v257.072c0 30.417 24.747 55.163 55.166 55.163h401.666c30.418 0 55.164-24.746 55.164-55.163v-257.072z"
  }));
}

function SvgComponent$4() {
  return /* @__PURE__ */createElement("svg", {
    height: 20,
    width: 20,
    viewBox: "0 0 511.606 511.606",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */createElement("path", {
    d: "m436.594 74.943c-99.917-99.917-261.637-99.932-361.568 0-80.348 80.347-95.531 199.817-48.029 294.96l-26.335 115.839c-3.423 15.056 10.071 28.556 25.133 25.133l115.839-26.335c168.429 84.092 369.846-37.653 369.846-228.812 0-68.29-26.595-132.494-74.886-180.785zm-127.451 244.451h-160c-11.598 0-21-9.402-21-21s9.402-21 21-21h160c11.598 0 21 9.402 21 21s-9.402 21-21 21zm53.334-85.333h-213.334c-11.598 0-21-9.402-21-21s9.402-21 21-21h213.334c11.598 0 21 9.402 21 21s-9.403 21-21 21z"
  }));
}

var iconMapping = {
  email: SvgComponent,
  call: SvgComponent$1,
  question: SvgComponent$2,
  envelop: SvgComponent$3,
  chat: SvgComponent$4
};

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var resetButton = /*#__PURE__*/css({
  name: "p0e0za-resetButton",
  styles: "border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;font:inherit;line-height:normal;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,Arial,sans-serif;-webkit-appearance:none;&:hover{cursor:pointer;};label:resetButton;"
});
var buttonStyle = /*#__PURE__*/css({
  name: "ds7k9b-buttonStyle",
  styles: "background-color:rgb(3,54,61);color:rgb(240,235,235) !important;border-color:rgb(3,54,61);padding:10px 15px;border-radius:5px;font-size:16px;letter-spacing:normal;;label:buttonStyle;"
});

var Button = function Button(ref) {
  var children = ref.children;
  var className = ref.className;
  var type = ref.type;
  if (type === void 0) type = "button";
  var onClick = ref.onClick;
  var rest = objectWithoutProperties(ref, ["children", "className", "type", "onClick"]);
  var props = rest;
  return createElement("button", Object.assign({}, {
    className: clsx2(resetButton, buttonStyle, className),
    type: type,
    onClick: onClick,
    "aria-label": "button"
  }, props), children);
};

var MessageButton = function MessageButton(ref) {
  var handleClick = ref.handleClick;
  var uiConfig = ref.uiConfig;
  var isPreview = ref.isPreview;
  var isInline = ref.isInline;
  var isMobile = ref.isMobile;
  var theme = useTheme();
  var Icon = uiConfig.icon ? iconMapping[uiConfig.icon] : iconMapping.email;
  var onClickFn = isPreview ? function () {} : handleClick;
  var inlineStyle = /*#__PURE__*/css({
    name: "1ne20e5-inlineStyle",
    styles: "max-width:250px;;label:inlineStyle;"
  });
  var modalStyle = /*#__PURE__*/css({
    name: "q0dpau-modalStyle",
    styles: "position:fixed;;label:modalStyle;"
  });
  return /* @__PURE__ */createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "1kp5ofj-className",
      styles: "padding:0px;bottom:0px;right:0px;overflow:visible;opacity:1;border:0px;z-index:999998;transition-duration:250ms;transition-timing-function:cubic-bezier(0.645,0.045,0.355,1);transition-property:opacity,top,bottom;;label:className;"
    }), isInline ? inlineStyle : modalStyle)
  }, /* @__PURE__ */createElement(Button, {
    className: cx( /*#__PURE__*/css("background-color:", theme.themeColor, " !important;color:#f0ebeb !important;fill:#f0ebeb !important;padding:11px 16px;border-radius:999rem;bottom:0;letter-spacing:0.6;font-size:16px;font-weight:700;border:none;overflow:visible;outline:none;&::active,&::focus{outline:none;};label:className;"), isMobile ? /*#__PURE__*/css({
      name: "1xlv6t4-className",
      styles: "width:50px;height:50px;border-radius:25px;padding:0;;label:className;"
    }) : null),
    onClick: onClickFn
  }, /* @__PURE__ */createElement("span", {
    className: /*#__PURE__*/css({
      name: "lo7z6q-className",
      styles: "vertical-align:middle;display:inline-block;max-width:100%;;label:className;"
    })
  }, /* @__PURE__ */createElement(Icon, null)), uiConfig.ctaTitle && !isMobile ? /* @__PURE__ */createElement("span", {
    className: /*#__PURE__*/css({
      name: "182grgr-className",
      styles: "display:inline-block;padding-left:10px;;label:className;"
    })
  }, uiConfig.ctaTitle) : null));
};

function SvgComponent$5() {
  return /* @__PURE__ */createElement("svg", {
    viewBox: "0 0 492 492",
    width: 10,
    height: 10,
    style: {
      fill: "white"
    }
  }, /* @__PURE__ */createElement("path", {
    d: "M465.064 207.562H26.908C12.076 207.562 0 219.698 0 234.53v22.804c0 14.832 12.072 27.104 26.908 27.104h438.156c14.84 0 26.936-12.272 26.936-27.104V234.53c0-14.832-12.096-26.968-26.936-26.968z"
  }));
}

var ModalHeader = function ModalHeader(ref) {
  var handleHideForm = ref.handleHideForm;
  var uiConfig = ref.uiConfig;
  var ref$1 = useTheme();
  var classNames = ref$1.classNames;
  var themeColor = ref$1.themeColor;
  return /* @__PURE__ */createElement("div", {
    className: clsx2(classNames.root, /*#__PURE__*/css("color:rgb(240,235,235);padding:0.571429rem 1rem;background:", themeColor, ";;label:className;"))
  }, /* @__PURE__ */createElement("div", {
    className: /*#__PURE__*/css({
      name: "pb62b6-className",
      styles: "display:flex;align-content:stretch;align-items:center;min-height:1rem;;label:className;"
    })
  }, /* @__PURE__ */createElement("p", {
    className: clsx2(classNames.root, /*#__PURE__*/css({
      name: "dub0b8-className",
      styles: "font-weight:700;text-align:center;font-size:16px;flex-grow:1;margin:0;line-height:1.5;margin-left:44px;margin-right:0;;label:className;"
    }))
  }, uiConfig.ctaTitle), /* @__PURE__ */createElement(Button, {
    className: /*#__PURE__*/css("background-color:", themeColor, ";border-color:", themeColor, ";;label:className;"),
    onClick: handleHideForm
  }, /* @__PURE__ */createElement(SvgComponent$5, null))));
};

var ErrorMessage = function ErrorMessage(ref) {
  var message = ref.message;
  return createElement("small", {
    className: /*#__PURE__*/css({
      name: "4mpuml-className",
      styles: "color:#dc3545;;label:className;"
    })
  }, message);
};

var SelectComponent = function SelectComponent(ref) {
  var error = ref.error;
  var onChange = ref.onChange;
  var options = ref.options;

  var handleOnChange = function handleOnChange(option) {
    onChange(option.value);
  };

  return /* @__PURE__ */createElement(Fragment, null, /* @__PURE__ */createElement(Select, {
    options: options,
    onChange: handleOnChange,
    isSearchable: false
  }), error && /* @__PURE__ */createElement(ErrorMessage, {
    message: error.message
  }));
};

var Label = function Label(ref) {
  var name = ref.name;
  var label = ref.label;
  return createElement("label", {
    className: /*#__PURE__*/css({
      name: "16u4jja-className",
      styles: "display:block;padding-bottom:5px;font-weight:400 !important;font-size:16px;text-align:left;letter-spacing:normal;;label:className;"
    }),
    htmlFor: name
  }, label);
};

var Input = function Input(ref) {
  var obj;
  var type = ref.type;
  var name = ref.name;
  var placeholder = ref.placeholder;
  var error = ref.error;
  var register = ref.register;
  var ref$1 = useTheme();
  var classNames = ref$1.classNames;
  return /* @__PURE__ */createElement(Fragment, null, /* @__PURE__ */createElement("input", Object.assign({}, {
    id: name,
    className: clsx2(classNames.fieldStyle, (obj = {}, obj[classNames.fieldErrorStyle] = error, obj)),
    type: type,
    placeholder: placeholder
  }, register(name))), error && /* @__PURE__ */createElement(ErrorMessage, {
    message: error.message
  }));
};

var Textarea = function Textarea(ref) {
  var obj;
  var name = ref.name;
  var placeholder = ref.placeholder;
  var error = ref.error;
  var register = ref.register;
  var ref$1 = useTheme();
  var classNames = ref$1.classNames;
  return /* @__PURE__ */createElement(Fragment, null, /* @__PURE__ */createElement("textarea", Object.assign({}, {
    id: name,
    className: clsx2(classNames.textAreaStyle, (obj = {}, obj[classNames.fieldErrorStyle] = error, obj)),
    placeholder: placeholder,
    rows: 5
  }, register(name))), error && /* @__PURE__ */createElement(ErrorMessage, {
    message: error.message
  }));
};

var domain = "https://moin.bz";

var genRefLink = function genRefLink(pid) {
  return domain + "?ref=" + pid;
};

var FormFooter = function FormFooter(ref) {
  var isSubmitting = ref.isSubmitting;
  var submitButtonText = ref.submitButtonText;
  var pid = ref.pid;
  var theme = useTheme();
  return /* @__PURE__ */createElement("footer", {
    className: /*#__PURE__*/css({
      name: "w2f7tp-className",
      styles: "box-shadow:rgba(0,0,0,0.08) 0px -0.0714286rem 0.857143rem;padding:0.8rem 1.42857rem;border-top:0.0785714rem solid rgb(233,235,237);;label:className;"
    })
  }, /* @__PURE__ */createElement("div", {
    className: /*#__PURE__*/css("display:flex;-webkit-box-pack:justify;justify-content:space-between;align-items:center;", mq[0], "{width:100%;flex-direction:column-reverse;};label:className;")
  }, /* @__PURE__ */createElement("a", {
    className: /*#__PURE__*/css("font-size:11px;text-decoration:none;color:grey;", mq[0], "{margin-top:10px;};label:className;"),
    href: genRefLink(pid),
    target: "_blank",
    rel: "noreferrer"
  }, "Powered by", " ", /* @__PURE__ */createElement("img", {
    className: /*#__PURE__*/css({
      name: "1a7d9l2-className",
      styles: "height:16px;vertical-align:middle;;label:className;"
    }),
    src: "https://cdn.moin.bz/powered.png",
    alt: "logo"
  })), /* @__PURE__ */createElement(Button, {
    type: "submit",
    className: /*#__PURE__*/css("opacity:", isSubmitting ? 0.8 : 1, ";background-color:", theme.themeColor, ";border-color:", theme.themeColor, ";", mq[0], "{width:100%;};label:className;")
  }, isSubmitting ? /* @__PURE__ */createElement(Fragment, null, submitButtonText, "...") : /* @__PURE__ */createElement(Fragment, null, submitButtonText))));
};

var iconLineClassName = /*#__PURE__*/css({
  name: "1yitm8-iconLineClassName",
  styles: "height:5px;background-color:#4CAF50;display:block;border-radius:2px;position:absolute;z-index:10;;label:iconLineClassName;"
});
var rotateCircle = /*#__PURE__*/keyframes({
  name: "9gg04o-rotateCircle",
  styles: "0%{transform:rotate(-45deg);}5%{transform:rotate(-45deg);}12%{transform:rotate(-405deg);}100%{transform:rotate(-405deg);};label:rotateCircle;"
});
var iconLineTip = /*#__PURE__*/keyframes({
  name: "x4pxwq-iconLineTip",
  styles: "0%{width:0;left:1px;top:19px;}54%{width:0;left:1px;top:19px;}70%{width:50px;left:-8px;top:37px;}84%{width:17px;left:21px;top:48px;}100%{width:25px;left:14px;top:45px;};label:iconLineTip;"
});
var iconLineLong = /*#__PURE__*/keyframes({
  name: "1t3085g-iconLineLong",
  styles: "0%{width:0;right:46px;top:54px;}65%{width:0;right:46px;top:54px;}84%{width:55px;right:0px;top:35px;}100%{width:47px;right:8px;top:38px;};label:iconLineLong;"
});

var CheckIcon = function CheckIcon() {
  return createElement("div", {
    className: /*#__PURE__*/css({
      name: "1i20qq4-className",
      styles: "width:80px;height:115px;margin:0 auto;;label:className;"
    })
  }, /* @__PURE__ */createElement("div", {
    className: /*#__PURE__*/css("width:80px;height:80px;position:relative;border-radius:50%;box-sizing:content-box;border:4px solid #4CAF50;&::before{top:3px;left:-2px;width:30px;transform-origin:100% 50%;border-radius:100px 0 0 100px;}&::after{top:0;left:30px;width:60px;transform-origin:0 50%;border-radius:0 100px 100px 0;animation:", rotateCircle, " 4.25s ease-in;}&::before,&::after{content:'';height:100px;position:absolute;background:#FFFFFF;transform:rotate(-45deg);};label:className;")
  }, /* @__PURE__ */createElement("span", {
    className: clsx2(iconLineClassName, /*#__PURE__*/css("top:46px;left:14px;width:25px;transform:rotate(45deg);animation:", iconLineTip, " 0.75s;;label:className;"))
  }), /* @__PURE__ */createElement("span", {
    className: clsx2(iconLineClassName, /*#__PURE__*/css("top:38px;right:8px;width:47px;transform:rotate(-45deg);animation:", iconLineLong, " 0.75s;;label:className;"))
  }), /* @__PURE__ */createElement("div", {
    className: /*#__PURE__*/css({
      name: "1ojeb3o-className",
      styles: "top:-4px;left:-4px;z-index:10;width:80px;height:80px;border-radius:50%;position:absolute;box-sizing:content-box;border:4px solid rgba(76,175,80,.5);;label:className;"
    })
  }), /* @__PURE__ */createElement("div", {
    className: /*#__PURE__*/css({
      name: "i0cap3-className",
      styles: "top:8px;width:5px;left:26px;z-index:1;height:85px;position:absolute;transform:rotate(-45deg);background-color:#FFFFFF;;label:className;"
    })
  })));
};

var phoneOuterKeyframe = /*#__PURE__*/keyframes({
  name: "1ce4el7-phoneOuterKeyframe",
  styles: "{0%{transform:translate3d(0,0,0) scale(1);box-shadow:0 0 0 0em rgba(#3498db,0),0em 0.05em 0.1em rgba(#000000,0.2);}33.3333%{transform:translate3d(0,0,0) scale(1.1);box-shadow:0 0 0 0em rgba(#3498db,0.1),0em 0.05em 0.1em rgba(#000000,0.5);}66.6666%{transform:translate3d(0,0,0) scale(1);box-shadow:0 0 0 0.5em rgba(#3498db,0),0em 0.05em 0.1em rgba(#000000,0.2);}100%{transform:translate3d(0,0,0) scale(1);box-shadow:0 0 0 0em rgba(#3498db,0),0em 0.05em 0.1em rgba(#000000,0.2);}};label:phoneOuterKeyframe;"
});
var phoneInnerKeyframe = /*#__PURE__*/keyframes({
  name: "1wg5045-phoneInnerKeyframe",
  styles: "0%{opacity:1;transform:translate3d(0,0,0) scale(0);}33.3333%{opacity:1;transform:translate3d(0,0,0) scale(0.9);}66.6666%{opacity:0;transform:translate3d(0,0,0) scale(0);}100%{opacity:0;transform:translate3d(0,0,0) scale(0);};label:phoneInnerKeyframe;"
});
var phoneIconKeyframe = /*#__PURE__*/keyframes({
  name: "1y0iwfa-phoneIconKeyframe",
  styles: "0%{transform:translate3d(0em,0,0);}2%{transform:translate3d(0.01em,0,0);}4%{transform:translate3d(-0.01em,0,0);}6%{transform:translate3d(0.01em,0,0);}8%{transform:translate3d(-0.01em,0,0);}10%{transform:translate3d(0.01em,0,0);}12%{transform:translate3d(-0.01em,0,0);}14%{transform:translate3d(0.01em,0,0);}16%{transform:translate3d(-0.01em,0,0);}18%{transform:translate3d(0.01em,0,0);}20%{transform:translate3d(-0.01em,0,0);}22%{transform:translate3d(0.01em,0,0);}24%{transform:translate3d(-0.01em,0,0);}26%{transform:translate3d(0.01em,0,0);}28%{transform:translate3d(-0.01em,0,0);}30%{transform:translate3d(0.01em,0,0);}32%{transform:translate3d(-0.01em,0,0);}34%{transform:translate3d(0.01em,0,0);}36%{transform:translate3d(-0.01em,0,0);}38%{transform:translate3d(0.01em,0,0);}40%{transform:translate3d(-0.01em,0,0);}42%{transform:translate3d(0.01em,0,0);}44%{transform:translate3d(-0.01em,0,0);}46%{transform:translate3d(0em,0,0);};label:phoneIconKeyframe;"
});
var width = 80;
var phoneClass = /*#__PURE__*/css("position:relative;display:block;margin:0 auto;margin-bottom:20px;width:", width, "px;height:", width, "px;font-size:25vmin;background-color:#3498db;border-radius:0.5em;box-shadow:0 0 0 0em rgba(#3498db,0),0em 0.05em 0.1em rgba(#000000,0.2);transform:translate3d(0,0,0) scale(1);&::before,&::after{position:absolute;content:\"\";}&::before{top:0;left:0;width:", width, "px;height:", width, "px;background-color:rgba(#fff,0.1);border-radius:100%;opacity:1;transform:translate3d(0,0,0) scale(0);}&::after{top:", width / 4, "px;left:", width / 4, "px;width:", width / 2, "px;height:", width / 2, "px;background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTYuNiAxMC44YzEuNCAyLjggMy44IDUuMSA2LjYgNi42bDIuMi0yLjJjLjMtLjMuNy0uNCAxLS4yIDEuMS40IDIuMy42IDMuNi42LjUgMCAxIC40IDEgMVYyMGMwIC41LS41IDEtMSAxLTkuNCAwLTE3LTcuNi0xNy0xNyAwLS42LjQtMSAxLTFoMy41Yy41IDAgMSAuNCAxIDEgMCAxLjIuMiAyLjUuNiAzLjYuMS40IDAgLjctLjIgMWwtMi4zIDIuMnoiIGZpbGw9IiNmZmZmZmYiLz48L3N2Zz4=);background-position:50% 50%;background-repeat:no-repeat;background-size:cover;transform:translate3d(0,0,0);};label:phoneClass;");
var isAnimating = /*#__PURE__*/css("animation:", phoneOuterKeyframe, " 7000ms infinite;&::before{animation:", phoneInnerKeyframe, " 7000ms infinite;}&::after{animation:", phoneIconKeyframe, " 7000ms infinite;};label:isAnimating;");

var PhoneIcon = function PhoneIcon() {
  return createElement("i", {
    className: clsx2(phoneClass, isAnimating)
  });
};

var Form = function Form(ref) {
  var locale = ref.locale;
  var pid = ref.pid;
  var endpoint = ref.endpoint;
  var formSchema = ref.formSchema;
  var uiConfig = ref.uiConfig;
  var onListenFormSubmit = ref.onListenFormSubmit;
  var isPreview = ref.isPreview;
  var parentShowSuccessMessage = ref.parentShowSuccessMessage;
  var schemaId = ref.schemaId;
  var ref$1 = useTheme();
  var classNames = ref$1.classNames;
  var validatorSchema = genYupValidatorBySchema({
    schema: formSchema,
    locale: locale
  });
  var ref$2 = useForm({
    resolver: yupResolver(validatorSchema)
  });
  var control = ref$2.control;
  var register = ref$2.register;
  var handleSubmit = ref$2.handleSubmit;
  var errors = ref$2.formState.errors;
  var ref$3 = useState(parentShowSuccessMessage);
  var showSuccessMessage = ref$3[0];
  var setShowSuccessMessage = ref$3[1];
  var ref$4 = useState(false);
  var showError = ref$4[0];
  var setShowError = ref$4[1];
  var ref$5 = useState(false);
  var isSubmitting = ref$5[0];
  var setIsSubmitting = ref$5[1];
  useEffect(function () {
    setShowSuccessMessage(parentShowSuccessMessage);
  }, [parentShowSuccessMessage]);

  var onSubmit = function onSubmit(data) {
    if (!isPreview) {
      setIsSubmitting(true);

      if (onListenFormSubmit) {
        onListenFormSubmit(data);
      }

      fetch(endpoint + "/api/app/" + pid + "/message", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          config: schemaId,
          content: data
        })
      }).then(function () {
        return setShowSuccessMessage(true);
      }).catch(function () {
        return setShowError(true);
      }).finally(function () {
        return setIsSubmitting(false);
      });
    }
  };

  if (showError) {
    return /* @__PURE__ */createElement("div", {
      className: /*#__PURE__*/css({
        name: "hb2v7g-className",
        styles: "text-align:center;padding:20px 30px;;label:className;"
      })
    }, /* @__PURE__ */createElement(PhoneIcon, null), /* @__PURE__ */createElement("div", null, uiConfig.errorMessage));
  }

  if (showSuccessMessage) {
    return /* @__PURE__ */createElement("div", {
      className: /*#__PURE__*/css({
        name: "16wkaiz-className",
        styles: "text-align:center;padding:20px 10px;;label:className;"
      })
    }, /* @__PURE__ */createElement(CheckIcon, null), uiConfig.successMessage);
  }

  return /* @__PURE__ */createElement("form", {
    className: clsx2(classNames.root, /*#__PURE__*/css({
      name: "g9cwbl-className",
      styles: "display:flex;flex-direction:column;height:100%;overflow-y:hidden;margin-block-end:0px;>:first-child{padding-bottom:2.14286rem;}position:relative;;label:className;"
    })),
    name: "contact",
    method: "POST",
    "data-netlify": "true",
    "netlify-honeypot": "bot-field",
    onSubmit: handleSubmit(onSubmit)
  }, /* @__PURE__ */createElement("div", {
    className: clsx2(classNames.root, /*#__PURE__*/css({
      name: "ujsdmq-className",
      styles: "padding-top:23px;padding-left:23px;padding-right:23px;flex-grow:2;overflow-y:auto;overflow-x:hidden;;label:className;"
    }))
  }, /* @__PURE__ */createElement("div", {
    "data-netlify-recaptcha": "true"
  }), formSchema.map(function (item) {
    var id = item.id;
    var component = item.component;
    var labelText = item.labelText;
    var placeholder = item.placeholder;
    var validators = item.validators;
    var field;

    if (component === "input") {
      field = /* @__PURE__ */createElement(Input, {
        type: "text",
        name: id,
        placeholder: placeholder,
        register: register,
        error: errors[id]
      });
    } else if (component === "textarea") {
      field = /* @__PURE__ */createElement(Textarea, {
        name: id,
        placeholder: placeholder,
        register: register,
        error: errors[id]
      });
    } else if (component === "select") {
      field = /* @__PURE__ */createElement(Controller, {
        control: control,
        name: id,
        render: function render(ref) {
          var onChange = ref.field.onChange;
          return createElement(SelectComponent, {
            onChange: onChange,
            options: item.options,
            error: errors[id]
          });
        }
      });
    }

    return /* @__PURE__ */createElement("div", {
      className: /*#__PURE__*/css({
        name: "2laeay-className",
        styles: "margin-bottom:20px;;label:className;"
      })
    }, /* @__PURE__ */createElement(Label, {
      name: "content." + id,
      label: labelText
    }), field);
  })), /* @__PURE__ */createElement(FormFooter, {
    pid: pid,
    isSubmitting: isSubmitting,
    submitButtonText: uiConfig.submitButtonText
  }));
};

var Modal = function Modal(ref) {
  var handleHideForm = ref.handleHideForm;
  var locale = ref.locale;
  var isShownModal = ref.isShownModal;
  var endpoint = ref.endpoint;
  var pid = ref.pid;
  var formSchema = ref.formSchema;
  var uiConfig = ref.uiConfig;
  var isMobile = ref.isMobile;
  var onListenFormSubmit = ref.onListenFormSubmit;
  var isPreview = ref.isPreview;
  var parentShowSuccessMessage = ref.parentShowSuccessMessage;
  var schemaId = ref.schemaId;
  var isInline = ref.isInline;
  var ref$1 = useTheme();
  var classNames = ref$1.classNames;
  var inlineStyle = /*#__PURE__*/css(isShownModal ? "opacity: 1" : "opacity: 0", ";label:inlineStyle;");
  var modalStyle = /*#__PURE__*/css("position:fixed;", isShownModal ? "bottom: 0px; opacity: 1" : "top: -9999px; opacity: 0", ";right:0px;;label:modalStyle;");
  return /* @__PURE__ */createElement("div", {
    className: clsx2(classNames.root, /*#__PURE__*/css("z-index:1000;width:375px;height:100%;opacity:1;border:0px;transition-duration:250ms;transition-timing-function:cubic-bezier(0.645,0.045,0.355,1);transition-property:opacity,top,bottom;z-index:999999;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,Arial,sans-serif;visibility:", isShownModal ? "visible" : "hidden", ";box-sizing:border-box;", isMobile ? "\n                max-height: 100%;\n                width: 100%;\n                height: 100%;\n                padding: 0;\n            " : null, ";label:className;"), isInline ? inlineStyle : modalStyle)
  }, /* @__PURE__ */createElement("div", {
    className: /*#__PURE__*/css({
      name: "5ci8ge-className",
      styles: "height:100%;;label:className;"
    })
  }, /* @__PURE__ */createElement("div", {
    className: clsx2(classNames.root, /*#__PURE__*/css({
      name: "1m0q9dk-className",
      styles: "display:flex;flex-direction:column;box-sizing:border-box;box-shadow:rgba(0,0,0,0.2) 0px 0px 0.428571rem 0px;border-radius:0.571429rem;height:100%;width:100%;overflow:hidden;background-color:white;;label:className;"
    }))
  }, /* @__PURE__ */createElement(ModalHeader, {
    handleHideForm: handleHideForm,
    uiConfig: uiConfig
  }), /* @__PURE__ */createElement(Form, {
    locale: locale,
    endpoint: endpoint,
    pid: pid,
    formSchema: formSchema,
    uiConfig: uiConfig,
    onListenFormSubmit: onListenFormSubmit,
    isPreview: isPreview,
    parentShowSuccessMessage: parentShowSuccessMessage,
    schemaId: schemaId
  }))));
};

var CiaoCiaoForm = function CiaoCiaoForm(ref) {
  var handleMessageButtonClick = ref.handleMessageButtonClick;
  var handleHideForm = ref.handleHideForm;
  var hideMessageButton = ref.hideMessageButton;
  var endpoint = ref.endpoint;
  var pid = ref.pid;
  var pluginConfig = ref.pluginConfig;
  var schemaId = ref.schemaId;
  var isMobile = ref.isMobile;
  var locale = ref.locale;
  var isInline = ref.isInline;
  if (isInline === void 0) isInline = false;
  var isShownModal = ref.isShownModal;
  if (isShownModal === void 0) isShownModal = false;
  var isPreview = ref.isPreview;
  if (isPreview === void 0) isPreview = false;
  var parentShowSuccessMessage = ref.parentShowSuccessMessage;
  if (parentShowSuccessMessage === void 0) parentShowSuccessMessage = false;
  var onListenFormSubmit = ref.onListenFormSubmit;
  var theme = createStyle({
    themeColor: pluginConfig.uiConfig.color
  });
  var ref$1 = useState(isShownModal);
  var componentIsShownModal = ref$1[0];
  var setComponentIsShownModal = ref$1[1];

  var onMessageButtonClick = function onMessageButtonClick() {
    if (handleMessageButtonClick) {
      handleMessageButtonClick();
    } else {
      setComponentIsShownModal(!componentIsShownModal);
    }
  };

  var onHideForm = function onHideForm() {
    if (!isInline) {
      if (handleHideForm) {
        handleHideForm();
      } else {
        setComponentIsShownModal(false);
      }
    }
  };

  useEffect(function () {
    setComponentIsShownModal(isShownModal);
  }, [isShownModal]);
  return /* @__PURE__ */createElement(ThemeProvider, {
    theme: theme
  }, componentIsShownModal || hideMessageButton ? null : /* @__PURE__ */createElement(MessageButton, {
    isPreview: isPreview,
    isInline: isInline,
    isMobile: isMobile,
    handleClick: onMessageButtonClick,
    uiConfig: pluginConfig.uiConfig
  }), /* @__PURE__ */createElement(Modal, {
    locale: locale,
    endpoint: endpoint,
    pid: pid,
    handleHideForm: onHideForm,
    isMobile: isMobile,
    isShownModal: componentIsShownModal,
    formSchema: pluginConfig.config,
    uiConfig: pluginConfig.uiConfig,
    onListenFormSubmit: onListenFormSubmit,
    isPreview: isPreview,
    parentShowSuccessMessage: parentShowSuccessMessage,
    schemaId: schemaId,
    isInline: isInline
  }));
};

export { CiaoCiaoForm, iconMapping };